import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSlackMessageMutationVariables = Types.Exact<{
  input: Types.UpdateSlackMessageInput;
}>;

export type UpdateSlackMessageMutation = {
  __typename?: 'Mutation';
  updateSlackMessage: {
    __typename?: 'SlackMessage';
    id: any;
    text?: string | null;
    blocks?: any | null;
    threadTs?: string | null;
    createdAt: any;
    updatedAt: any;
    installation?: {
      __typename?: 'SlackInstallation';
      id: any;
      teamDomain?: string | null;
    } | null;
    channel?: {
      __typename?: 'SlackChannel';
      id: any;
      name?: string | null;
    } | null;
  };
};

export const UpdateSlackMessageDocument = gql`
  mutation UpdateSlackMessage($input: UpdateSlackMessageInput!) {
    updateSlackMessage(input: $input) {
      id
      text
      installation {
        id
        teamDomain
      }
      channel {
        id
        name
      }
      blocks
      threadTs
      createdAt
      updatedAt
    }
  }
`;
export type UpdateSlackMessageMutationFn = Apollo.MutationFunction<
  UpdateSlackMessageMutation,
  UpdateSlackMessageMutationVariables
>;

/**
 * __useUpdateSlackMessageMutation__
 *
 * To run a mutation, you first call `useUpdateSlackMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlackMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlackMessageMutation, { data, loading, error }] = useUpdateSlackMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlackMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSlackMessageMutation,
    UpdateSlackMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSlackMessageMutation,
    UpdateSlackMessageMutationVariables
  >(UpdateSlackMessageDocument, options);
}
export type UpdateSlackMessageMutationHookResult = ReturnType<
  typeof useUpdateSlackMessageMutation
>;
export type UpdateSlackMessageMutationResult =
  Apollo.MutationResult<UpdateSlackMessageMutation>;
export type UpdateSlackMessageMutationOptions = Apollo.BaseMutationOptions<
  UpdateSlackMessageMutation,
  UpdateSlackMessageMutationVariables
>;
